'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  const $photoFilterForm = $('form#photo-filter-form');
  const $photoFilterSelect = $photoFilterForm.find('select');
  $photoFilterForm.on('submit', function (event) {
    const $this = $(this);
    const $select = $this.find('select');
    if ($select.val() === '/photos') {
      event.preventDefault();
      location.href = $select.val();
    }
  });

  // remove disabled button when form selection occurs
  $photoFilterSelect.on('change', function () {
    $photoFilterForm.find('input[type="submit"]').removeAttr('disabled');
  });

})(jQuery);
